export default {
    name: 'review',
    serverName: 'api/v1/review/',
    apiUrl: '/v1/review/'
};
